import type { ReactNode } from 'react';

export const symbol_call_missed_outgoing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M780-571 517-308q-9 9-20 13t-22 4q-11 0-22-4t-20-13L140-601q-9-9-9-21.16t8.61-21Q149-652 161.47-652q12.46 0 21.53 9l292 292 266-266H559q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h251q12.75 0 21.38 8.62Q840-659.75 840-647v258q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-182Z"
		/>
	</svg>
);
